import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditOrganisationComponent } from './modals/edit-organisation/edit-organisation.component';
import { ManagementService } from './management.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertComponent } from '../../shared/modals/alert/alert.component';
import { SharedService } from '../../shared/shared.service';
import { AccessProgramComponent } from './modals/access-program/access-program.component';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import { POSTHOG_EVENT_ADD_ORGANIZATION } from 'src/app/shared/constants/posthog-events.constants';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
	selector: 'app-management',
	templateUrl: './management.component.html',
	styleUrls: ['./management.component.scss']
})
export class ManagementComponent implements OnInit {
	headerTitle = 'Management';
	organisationData: any;
	blockLoader: string = 'blockLoader';

	constructor(
		public dialog: MatDialog,
		private router: Router,
		private organisationService: ManagementService,
		private snackbar: MatSnackBar,
		private spinner: NgxSpinnerService,
		private sharedService: SharedService,
		private posthog: PostHogService,
		private deviceDetectorService: DeviceDetectorService
	) { }

	async ngOnInit() {
		const email = localStorage.getItem('username');
		const haveAccess: any = await this.sharedService.checkOrganizationPageAccess(email ?? "");
		if (!haveAccess) return;
		this.getOrganisation();
	}

	editOrganization(orgData?: string) {
		// console.log("orgData",orgData);
		const dialogRef = this.dialog.open(EditOrganisationComponent, {
			maxWidth: '80%',
			minWidth: 'fit-content',
			data: orgData
		});

		dialogRef.afterClosed().subscribe(response => {
			// console.log(`Dialog result: ${response}`);
			if (response) {
				if (response) {
					this.snackbar.open(`Organization ${orgData ? 'updated' : 'created'} successfully`, "OK");
					if (!orgData) {
						this.posthog.capture(POSTHOG_EVENT_ADD_ORGANIZATION, {
							'User email': localStorage.getItem('username'),
							'device_type': this.deviceDetectorService.device,
							'role': localStorage.getItem('roleId'),
							'added user email id': ''
						});
					}
				} else {
					this.snackbar.open('Something went wrong!', "OK")
				}
			}
		});
	}

	accessProgram(orgData?: string) {
		const dialogRef = this.dialog.open(AccessProgramComponent, {
			maxWidth: '90%',
			minWidth: '70%',
			data: orgData
		});

		dialogRef.afterClosed().subscribe(response => {
			if (response) {
				if (response) {
					this.snackbar.open(`Organization ${orgData ? 'updated' : 'created'} successfully`, "OK");
				} else {
					this.snackbar.open('Something went wrong!', "OK")
				}
			}
		});
	}

	async deleteOrganization(orgId: string) {
		const dialogRef = this.dialog.open(AlertComponent, {
			data: {
				title: "Are you sure!",
				subTitle: "Do you want to delete this organization?"
			},
		});
		dialogRef.afterClosed().subscribe(async response => {
			if (response) {
				await this.spinner.show("blockLoader");
				const response = await this.organisationService.deleteOrganisation(orgId);
				await this.spinner.hide("blockLoader");
				if (response) {
					this.snackbar.open('Organization deleted successfully', "OK")
				} else {
					this.snackbar.open('Something went wrong while deleting organization!', "OK")
				}
			}
		});
	}

	getOrganisation() {
		this.organisationService.getOrganisation().subscribe((data) => {
			if (data.length) {
				this.organisationData = data;
				// console.log('this.organisationData',this.organisationData);
			}
		});
	}

	openTabsPage(organisationId: string) {
		this.router.navigate(['tabs'], {
			state: {
				organisationId
			}
		});
	}
}
